module.exports = __webpack_public_path__ + "img/taiurbanresort.b6bba88e.jpg";